export enum TabsQuiz {
  About = 'about',
  Result = 'result'
}
